import React from 'react';
import { StyleSheet, View } from 'react-native';

import { DesktopJackpotBar } from './DesktopJackpotBar';
import { DesktopRecentTablesBar, RECENT_TABLES_BAR_HEIGHT } from './DesktopRecentTablesBar';

/** The home frame's gap between the recent-tables bar and the jackpot bar. */
export const DESKTOP_COLUMN_GAP = 20;
export const DESKTOP_BARS_HEIGHT = RECENT_TABLES_BAR_HEIGHT;

/**
 * The desktop home's two columns. Figma's 1280 and 1440 frames split the content into two
 * near-equal halves (600 / 596 and 684 / 670), so the desktop layer splits it evenly at every
 * width: the columns grow together and what sits in them keeps the desktop scale, centred where
 * it does not fill its column. Every desktop screen uses the same split so the columns line up
 * from one screen to the next.
 */
export const getDesktopColumns = (contentWidth: number, scale: number) => {
	const gap = DESKTOP_COLUMN_GAP * scale;
	const half = Math.max(0, (contentWidth - gap) / 2);
	return { left: half, right: half, gap };
};

type Props = {
	contentWidth: number;
	scale: number;
	onRecentTablesPress: () => void;
};

/**
 * The row the desktop home ends on - recent tables on the left, the jackpot on the right - which
 * the lobby screens end on too, in the same place, so moving between them keeps the pair still.
 */
export const DesktopBottomBars = ({ contentWidth, scale, onRecentTablesPress }: Props) => {
	const columns = getDesktopColumns(contentWidth, scale);

	return (
		<View style={[styles.row, { columnGap: columns.gap }]}>
			<DesktopRecentTablesBar width={columns.left} scale={scale} onPress={onRecentTablesPress} />
			<DesktopJackpotBar width={columns.right} scale={scale} />
		</View>
	);
};

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
	},
});

export default DesktopBottomBars;
